export default "__VITE_ASSET__f66db9d8__"